module.exports = __webpack_public_path__ + "static/media/dish_card12.219da9e2.png";